/**
 * Flat-key i18n dictionary for the SKORPIO/BELINDA configurator.
 * EN baseline, IT (Cattelan's home market) and UK (Olexandra's market).
 *
 * Usage:  t('view.spec', lang)
 * Falls back to EN on missing key, then to the literal key.
 */

export const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'it', label: 'IT' },
  { code: 'uk', label: 'UK' },
];

export const I18N = {
  en: {
    'brand.title':            'CATTELAN',
    'brand.subtitle':         'SKORPIO + BELINDA · Configurator',
    'project.name':           'Project name',
    'project.client':         'Client',
    'project.designer':       'Designer',
    'project.address':        'Address',
    'project.date':           'Date',
    'project.status':         'Status',
    'project.notes':          'Notes',
    'project.tables':         'Tables',
    'project.chairs':         'Chairs',
    'project.total':          'Total',
    'action.pdf':             'PDF',
    'action.xlsx':            'XLSX',
    'action.save':            'Save',
    'action.load':            'Load',
    'action.add_table':       'Add table',
    'action.add_chair':       'Add chair',
    'action.ai_render':       'AI Render',
    'render.title':           'AI photorealistic render',
    'render.generating':      'Generating render…',
    'render.generating_hint': 'This typically takes 15–60 seconds.',
    'render.error':           'Render failed',
    'render.regenerate':      'Regenerate',
    'render.download':        'Download PNG',
    'panel.items':            'Items',
    'panel.configure':        'Configure',
    'panel.warnings':         'Warnings',
    'view.3d':                '3D preview',
    'view.spec':              'Specification',
    'view.plan':              'Plan (later)',
    'tab.spec':               'Item spec',
    'tab.copilot':            'Copilot',
    'tab.project':            'Project',
    'field.collection':       'Collection',
    'field.size':             'Size',
    'field.top':              'Top',
    'field.base':             'Base',
    'field.frame':            'Frame finish',
    'field.armrests':         'Armrests',
    'field.upholstery':       'Upholstery',
    'field.ceramic_insert':   'Ceramic insert',
    'field.brushed_profile':  'Brushed profile',
    'chair.no_arms':          'No arms',
    'chair.with_arms':        'With arms (B)',
    'price.on_request':       '— (Price on request)',
    'uphol.all_groups':       'All groups',
    'uphol.filter_placeholder': 'Filter by code or name...',
    'uphol.more':             'more — refine the filter',
    'empty.no_items':         'No items yet — add one below.',
    'empty.select_item':      'Select an item from the left.',
    'spec.kind':              'Kind',
    'spec.sku':               'SKU',
    'spec.description':       'Description',
    'spec.qty':               'Qty',
    'spec.unit':              'Unit (EUR)',
    'spec.line':              'Line (EUR)',
    'copilot.title':          'Configurator assistant',
    'copilot.placeholder':    'Ask: "add a 240×120 keramik table", "make it black"...',
    'copilot.send':           'Send',
    'copilot.thinking':       'Thinking...',
  },
  it: {
    'brand.title':            'CATTELAN',
    'brand.subtitle':         'SKORPIO + BELINDA · Configuratore',
    'project.name':           'Nome progetto',
    'project.client':         'Cliente',
    'project.designer':       'Designer',
    'project.address':        'Indirizzo',
    'project.date':           'Data',
    'project.status':         'Stato',
    'project.notes':          'Note',
    'project.tables':         'Tavoli',
    'project.chairs':         'Sedie',
    'project.total':          'Totale',
    'action.pdf':             'PDF',
    'action.xlsx':            'XLSX',
    'action.save':            'Salva',
    'action.load':            'Carica',
    'action.ai_render':       'Render AI',
    'render.title':           'Render fotorealistico AI',
    'render.generating':      'Generazione render…',
    'render.generating_hint': 'Di solito richiede 15–60 secondi.',
    'render.error':           'Render fallito',
    'render.regenerate':      'Rigenera',
    'render.download':        'Scarica PNG',
    'action.add_table':       'Aggiungi tavolo',
    'action.add_chair':       'Aggiungi sedia',
    'panel.items':            'Articoli',
    'panel.configure':        'Configura',
    'panel.warnings':         'Avvertenze',
    'view.3d':                'Anteprima 3D',
    'view.spec':              'Specifica',
    'view.plan':              'Pianta (prossimamente)',
    'tab.spec':               'Spec articolo',
    'tab.copilot':            'Copilota',
    'tab.project':            'Progetto',
    'field.collection':       'Collezione',
    'field.size':             'Dimensione',
    'field.top':              'Piano',
    'field.base':             'Base',
    'field.frame':            'Telaio',
    'field.armrests':         'Braccioli',
    'field.upholstery':       'Rivestimento',
    'field.ceramic_insert':   'Inserto ceramico',
    'field.brushed_profile':  'Profilo spazzolato',
    'chair.no_arms':          'Senza braccioli',
    'chair.with_arms':        'Con braccioli (B)',
    'price.on_request':       '— (Prezzo su richiesta)',
    'uphol.all_groups':       'Tutti i gruppi',
    'uphol.filter_placeholder': 'Filtra per codice o nome...',
    'uphol.more':             'altri — affina il filtro',
    'empty.no_items':         'Nessun articolo — aggiungi uno qui sotto.',
    'empty.select_item':      'Seleziona un articolo dalla colonna sinistra.',
    'spec.kind':              'Tipo',
    'spec.sku':               'SKU',
    'spec.description':       'Descrizione',
    'spec.qty':               'Q.tà',
    'spec.unit':              'Cad. (EUR)',
    'spec.line':              'Riga (EUR)',
    'copilot.title':          'Assistente configuratore',
    'copilot.placeholder':    'Chiedi: "aggiungi un tavolo 240×120 keramik", "fallo nero"...',
    'copilot.send':           'Invia',
    'copilot.thinking':       'Sto pensando...',
  },
  uk: {
    'brand.title':            'CATTELAN',
    'brand.subtitle':         'SKORPIO + BELINDA · Конфігуратор',
    'project.name':           'Назва проєкту',
    'project.client':         'Клієнт',
    'project.designer':       'Дизайнер',
    'project.address':        'Адреса',
    'project.date':           'Дата',
    'project.status':         'Статус',
    'project.notes':          'Нотатки',
    'project.tables':         'Столи',
    'project.chairs':         'Стільці',
    'project.total':          'Всього',
    'action.pdf':             'PDF',
    'action.xlsx':            'XLSX',
    'action.save':            'Зберегти',
    'action.load':            'Відкрити',
    'action.ai_render':       'AI рендер',
    'render.title':           'AI фотореалістичний рендер',
    'render.generating':      'Генерую рендер…',
    'render.generating_hint': 'Зазвичай 15–60 секунд.',
    'render.error':           'Рендер не вдався',
    'render.regenerate':      'Згенерувати ще',
    'render.download':        'Завантажити PNG',
    'action.add_table':       'Додати стіл',
    'action.add_chair':       'Додати стілець',
    'panel.items':            'Позиції',
    'panel.configure':        'Налаштування',
    'panel.warnings':         'Зауваження',
    'view.3d':                '3D-перегляд',
    'view.spec':              'Специфікація',
    'view.plan':              'План (пізніше)',
    'tab.spec':               'Деталі',
    'tab.copilot':            'Помічник',
    'tab.project':            'Проєкт',
    'field.collection':       'Колекція',
    'field.size':             'Розмір',
    'field.top':              'Стільниця',
    'field.base':             'База',
    'field.frame':            'Каркас',
    'field.armrests':         'Підлокітники',
    'field.upholstery':       'Оббивка',
    'field.ceramic_insert':   'Керамічна вставка',
    'field.brushed_profile':  'Шліфований профіль',
    'chair.no_arms':          'Без підлокітників',
    'chair.with_arms':        'З підлокітниками (B)',
    'price.on_request':       '— (Ціна за запитом)',
    'uphol.all_groups':       'Всі групи',
    'uphol.filter_placeholder': 'Фільтр за кодом чи назвою...',
    'uphol.more':             'ще — уточни фільтр',
    'empty.no_items':         'Поки нічого — додай нижче.',
    'empty.select_item':      'Обери позицію зліва.',
    'spec.kind':              'Тип',
    'spec.sku':               'SKU',
    'spec.description':       'Опис',
    'spec.qty':               'К-сть',
    'spec.unit':              'Шт. (EUR)',
    'spec.line':              'Лінія (EUR)',
    'copilot.title':          'Асистент конфігуратора',
    'copilot.placeholder':    'Запитай: "додай стіл 240×120 кераміка", "зроби чорним"...',
    'copilot.send':           'Надіслати',
    'copilot.thinking':       'Думаю...',
  },
};

export function t(key, lang = 'en') {
  return I18N[lang]?.[key] ?? I18N.en[key] ?? key;
}
